// extracted by mini-css-extract-plugin
module.exports = {"container":"DemoModeDashboard_container__1Pt5M","column":"DemoModeDashboard_column__M8GfX","title":"DemoModeDashboard_title__3Q2DV","input":"DemoModeDashboard_input__PthN4"};